import { T } from '@tribeplatform/react-components/i18n'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

export function NoCollectionTreeItem() {
  return (
    <div className="flex items-center gap-2 p-2">
      <SvgIcon name="folder" />
      <T id="Admin.SiteTree.NoCollection" defaultMessage="No collection" />
    </div>
  )
}
